'use strict';

var ComboboxExampleDirective = function ComboboxExampleDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/combobox-example.html'),
    controller: 'ComboboxExampleController'
  };
};
ComboboxExampleDirective.$inject = [];
module.exports = ComboboxExampleDirective;